import React from "react";
import { Button, Spinner } from "reactstrap";

interface AuthFormButtonProps {
  type?: "button" | "submit" | "reset";
  loading?: boolean;
  disabled?: boolean;
  onClick?: () => void;
  children: React.ReactNode;
  className?: string;
}

const AuthFormButton: React.FC<AuthFormButtonProps> = ({
  type = "submit",
  loading = false,
  disabled = false,
  onClick,
  children,
  className = "",
}) => {
  return (
    <Button
      type={type}
      color="warning"
      disabled={loading || disabled}
      className={`auth-submit-btn ${className}`}
      onClick={onClick}
    >
      {loading && <Spinner size="sm" className="me-2">Loading...</Spinner>}
      {children}
    </Button>
  );
};

export default AuthFormButton;



